// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"layout_pageContainer__3ht-H","content":"layout_content__eKJ5i"};